import type { DropdownOption } from '../../../../components/Dropdown'
import { Dropdown } from '../../../../components/Dropdown'
import { SearchInput } from '../../../../components/SearchInput'
import { LEAVE_POLICY_STATUS_FILTER_OPTIONS } from '../constants/hrmsLeavePolicies.constants'

interface LeavePolicyFiltersProps {
  searchQuery: string
  onSearchChange: (query: string) => void
  employeeGroupFilter: string
  onEmployeeGroupFilterChange: (val: string) => void
  employeeGroupOptions?: DropdownOption[]
  isEmployeeGroupLoading?: boolean
  statusFilter: string
  onStatusFilterChange: (val: string) => void
  onClearFilters: () => void
}

export function LeavePolicyFilters({
  searchQuery,
  onSearchChange,
  employeeGroupFilter,
  onEmployeeGroupFilterChange,
  employeeGroupOptions,
  isEmployeeGroupLoading = false,
  statusFilter,
  onStatusFilterChange,
  onClearFilters,
}: LeavePolicyFiltersProps) {
  const groupOptions =
    employeeGroupOptions && employeeGroupOptions.length > 0
      ? employeeGroupOptions
      : [{ label: 'All', value: 'All' }]

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-4 flex flex-wrap items-center gap-3 min-w-0 font-sans">
      <SearchInput
        value={searchQuery}
        onChange={onSearchChange}
        onClear={() => onSearchChange('')}
        placeholder="Search policy or employee group..."
        className="w-full sm:w-[320px] sm:flex-none"
      />

      <Dropdown
        options={groupOptions}
        value={employeeGroupFilter}
        onChange={onEmployeeGroupFilterChange}
        placeholder={isEmployeeGroupLoading ? 'Loading...' : 'All'}
        disabled={isEmployeeGroupLoading}
        className="w-full sm:w-[200px] flex-none"
        labelClassName="whitespace-nowrap [text-overflow:clip] overflow-visible"
      />

      <Dropdown
        options={LEAVE_POLICY_STATUS_FILTER_OPTIONS}
        value={statusFilter}
        onChange={onStatusFilterChange}
        placeholder="All Status"
        className="w-full sm:w-[160px] flex-none"
        labelClassName="whitespace-nowrap [text-overflow:clip] overflow-visible"
      />

      <button
        type="button"
        onClick={onClearFilters}
        className="text-xs font-semibold text-[#146971] hover:text-[#0f565d] hover:underline cursor-pointer shrink-0 ml-auto sm:ml-0"
      >
        Clear Filters
      </button>
    </div>
  )
}

